import React, { useEffect, useRef } from "react";

const CustomCursor = () => {
  const cursorRef = useRef(null);
  const cursorInnerRef = useRef(null);

  useEffect(() => {
    const cursor = cursorRef.current;
    const cursorInner = cursorInnerRef.current;
    const links = document.querySelectorAll("a");

    const handleMouseMove = (e) => {
      const x = e.clientX;
      const y = e.clientY;
      if (cursor) {
        cursor.style.transform = `translate3d(calc(${x}px - 50%), calc(${y}px - 50%), 0)`;
      }
      if (cursorInner) {
        cursorInner.style.left = `${x}px`;
        cursorInner.style.top = `${y}px`;
      }
    };

    const handleMouseDown = () => {
      cursor?.classList.add("click");
      cursorInner?.classList.add("custom-cursor__innerhover");
    };

    const handleMouseUp = () => {
      cursor?.classList.remove("click");
      cursorInner?.classList.remove("custom-cursor__innerhover");
    };

    const handleLinkHover = () => {
      cursor?.classList.add("custom-cursor__hover");
    };

    const handleLinkLeave = () => {
      cursor?.classList.remove("custom-cursor__hover");
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mousedown", handleMouseDown);
    document.addEventListener("mouseup", handleMouseUp);

    links.forEach((link) => {
      link.addEventListener("mouseover", handleLinkHover);
      link.addEventListener("mouseleave", handleLinkLeave);
    });

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mousedown", handleMouseDown);
      document.removeEventListener("mouseup", handleMouseUp);
      links.forEach((link) => {
        link.removeEventListener("mouseover", handleLinkHover);
        link.removeEventListener("mouseleave", handleLinkLeave);
      });
    };
  }, []);

  return (
    <>
      <div className="custom-cursor__cursor" ref={cursorRef}></div>
      <div className="custom-cursor__cursor-two" ref={cursorInnerRef}></div>
    </>
  );
};

export default CustomCursor;
